import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTech, unloadTech, viewTech } from '../../modules/techModule/tech';
import {
  unloadTechPlan,
  viewTechPlan,
} from '../../modules/techModule/techPlan';
import {
  unloadTechRslt,
  viewTechRslt,
} from '../../modules/techModule/techRslt';
import * as techApi from '../../lib/api/tech';
import TechStepperTemplate from '../../components/techSupports/TechStepperTemplate';
import { listMidTechs } from '../../modules/techModule/techMids';

//id => rsltUuid임
const ApprovalTechViewContainer = ({ id }) => {
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState(0);
  const [activeTab, setActiveTab] = useState(0);

  const {
    project,
    tech,
    techPlan,
    techMids,
    techMidInfo,
    techRslt,
    user,
    loading,
  } = useSelector(({ techModule, loading, auth }) => ({
    user: auth.user,
    project: techModule.tech.project,
    tech: techModule.tech.tech,
    techMids: techModule.midTechs.techMids,
    techMidInfo: techModule.midTechs.techMidInfo,
    techPlan: techModule.techPlan.techPlan,
    techRslt: techModule.techRslt.techRslt,
    loading: loading['tech/VIEW_TECH_RSLT'],
  }));

  useEffect(() => {
    if (id) {
      dispatch(viewTechRslt(id));
    }
  }, [id]);

  useEffect(() => {
    if (techRslt?.reqUuid && techRslt?.planUuid) {
      dispatch(viewTech(techRslt?.reqUuid));
      dispatch(viewTechPlan(techRslt?.planUuid));
      const searchData = {
        reqUuid: techRslt?.reqUuid,
        planUuid: techRslt?.planUuid,
        prjUuid: techRslt?.prjUuid,
      };
      dispatch(listMidTechs(searchData));
    }
  }, [techRslt?.reqUuid]);

  useEffect(() => {
    if (tech) {
      // console.log(tech, 'tech');
      const step = parseInt(tech.reqGrade) - 1;
      const tab = getActiveTap(tech.reqGrade);
      setActiveStep(step);
      setActiveTab(tab);
    }
  }, [tech]);

  const checkMidTab = (techPlan) => {
    return techPlan?.plnTyp.includes('장기') ? 2 : 3;
  };

  const getActiveTap = (grade) => {
    let tab = 0;
    if (grade === '1') {
      tab = 0;
    } else if (grade === '2') {
      //지원확인
      tab = 1;
    } else if (grade === '3') {
      //작업계획
      tab = checkMidTab(techPlan);
    } else if (grade > 3) {
      tab = 3;
    }
    return tab;
  };

  const handleTabChange = (event, newValue) => {
    // console.log(newValue, 'newValue')
    // let newStep = newValue;
    setActiveTab(newValue);
  };

  const reloadTech = async (id) => {
    try {
      const res = await techApi.getTechById(id);
      if (res.data.info) {
        dispatch(setTech(res.data.info));
      }
    } catch (err) {
      console.log(err);
    }
  };

  if (!tech) {
    return null;
  }

  return (
    <TechStepperTemplate
      activeStep={activeStep}
      activeTab={activeTab}
      tech={tech}
      techMidInfo={techMidInfo}
      techMids={techMids}
      techRslt={techRslt}
      techPlan={techPlan}
      project={project}
      user={user}
      reloadTech={reloadTech}
      handleTabChange={handleTabChange}
    />
  );
};

export default ApprovalTechViewContainer;
